import { fetchMyPortfolios } from '@3fourteen/core';
import dayjs from 'dayjs';
import { mainBugsnag } from 'helpers/bugsnag';

export async function checkIfPortfolioGenerated(modelName: string) {
  try {
    const portfolios = await fetchMyPortfolios();

    const existingPortfolio = portfolios?.find(
      (port) => port.config?.model_name?.toLowerCase() === modelName.toLowerCase()
    );

    const lastModified = dayjs(existingPortfolio?.last_modified);
    const now = dayjs(Date.now());
    const timeDiff = now.diff(lastModified);

    if (existingPortfolio && timeDiff <= 65000) {
      return existingPortfolio;
    }

    return false;
  } catch (error: any) {
    mainBugsnag.notify(error, (event) => {
      event.context = 'fetchPortfolios() in checkIfPortfolioGenerated()';
      event.addMetadata('Meta', {
        userId: localStorage.getItem('databaseId'),
        testing: 'true',
        modelName,
      });
    });

    return false;
  }
}
